<template>
  <div v-if="lion_data" class="page-horse-item container mb-5 pb-5" style="max-width: 1000px;">

    <div class="pt-5">
      <div class="row py-1 bg-c bg-c">
        <div class="col-md-2">
          <span
            class="cp float-left text-white"
            @click="historyBack()"
            >
            <i class="fas fa-arrow-left"></i>
            {{lg('',{
              en: 'Back',
              zh: '',
            })}}
          </span>
        </div>
        <div v-if="0" class="col-md-8 text-center">
          <h3 class="op4 b">
            {{lion_data.horse_name}}
          </h3>
          <div v-if="lion_data.is_in_stud" class="ml-auto">
            <span
              class="ui-tag-in-stud"
              >
              {{lg('',{
                en: 'IN STUD',
                zh: '',
              })}}
            </span>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>

    <div class="lion-box d-flex my-5">

      <!-- left -->
      <div class="page-main-pic bg-c-darken h-100">
        <picColored
          class="sp-avatar"
          :img="lion_data.image_url"
        />
        <div class="text-center py-2">
          <h4 class="text-white mb-0">
            {{lion_data.item_name || 'Lion'}}
          </h4>
        </div>
      </div>

      <!-- right -->
      <div class="pc-ml-30px w-100 d-flex flex-column justify-content-between h-100">

        <!-- top -->
        <div>
          <div class="bg-c py-2">
            <h4 class="text-white mb-0 pl-3 text-center">
              {{lion_data.item_name || 'Lion'}}
              #{{lion_data.tokenId}}
            </h4>
          </div>
          <div class="bg-c-lighten-b px-3 py-2 c text-center">
            <div>
              <span class="mx-3">
                #{{lion_data.tokenId}}
              </span>
              <span class="mx-3">
                GEN:{{lion_data.generation}}
              </span>
            </div>
            <div class="my-2">
              {{lg('',{
                en: 'Cold down',
                zh: '冷却期',
              })}}:
              {{lion_data.breedLimitInfo.left_str }}
            </div>

            <div class="d-flex align-items-center justify-content-center pb-1">
              <div v-if="lion_data.price > 0" class="b c2">
                {{lion_data.price}}
                JGN
              </div>

              <div v-if="!status_checking_approve">

                <!-- my lion btns: -->
                <div v-if="is_my">

                  <button v-if="parseFloat(lion_data.price) > 0" @click="actionCancelSell()" class="btn btn-primary-b mx-3">
                    {{lg('',{
                      en: 'Cancel Sell',
                      zh: '取消卖出',
                    })}}
                  </button>

                  <button v-else-if="!is_approved" @click="actionApprove()" class="btn btn-primary-b mx-3">
                    {{lg('',{
                      en: 'Approve Sell',
                      zh: 'Approve 卖出',
                    })}}
                    <span v-if="status_ajaxing_approve">
                      ...
                    </span>
                  </button>

                  <button v-else-if="parseFloat(lion_data.price) == 0" @click="actionSell()" class="btn btn-primary-b mx-3">
                    {{lg('',{
                      en: 'Sell',
                      zh: '卖出',
                    })}}
                  </button>

                </div>

                <!-- none-my lion btns: -->
                <div v-if="!is_my && parseFloat(lion_data.price) > 0">

                  <button v-if="!is_approved" @click="actionApprove()" class="btn btn-primary-b mx-3">
                    {{lg('',{
                      en: 'Approve Buy',
                      zh: 'Approve 买入',
                    })}}
                    <span v-if="status_ajaxing_approve">
                      ...
                    </span>
                  </button>

                  <button v-else @click="actionBuy()" class="btn btn-primary-b mx-3">
                    {{lg('',{
                      en: 'Buy',
                      zh: '买入',
                    })}}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="lion_data.is_male && lion_data.is_in_stud" class="small">
              {{lg('',{
                en: 'Breading Price',
                zh: '繁殖价格',
              })}}:
              {{lion_data.auctionInfo.price}}
              {{lion_data.auctionInfo.priceToken}}

              {{lg('',{
                en: 'Time Left',
                zh: '剩余时间',
              })}}:
              {{lion_data.auctionInfo.timeLeft}}
            </div>
            <div class="pb-2 d-flex justify-content-center">
              <button
                v-if="
                  lion_data.is_male &&
                  !lion_data.is_in_stud
                "
                @click="$store.commit('setDataBusKey',{
                  data_on_breed: lion_data,
                })"
                class="btn btn-primary-b btn-lg"
                >
                <i class="fas fa-heart mx-1"></i>
                {{lg('',{
                  en: 'Put into Breed',
                  zh: '去繁殖',
                })}}
              </button>


               <!-- <button
                v-if="
                  lion_data.is_male &&
                  !lion_data.is_in_stud
                "
                @click="$store.commit('setDataBusKey',{
                  data_on_breed: lion_data,
                })"
                class="btn btn-primary-b btn-lg"
                >
                <i class="fas fa-heart mr-1"></i>
                {{lg('',{
                  en: 'Sell Now',
                  zh: '卖出',
                })}}
              </button> -->

              <router-link 
                v-if="
                  lion_data.is_male &&
                  lion_data.is_in_stud
                "
                :to="{name: 'breeding_item'}"
                @click.native="$store.commit('setDataBusKey',{
                  data_on_select_mate: lion_data,
                })"
                class="btn btn-primary-b btn-lg mx-3"
                >
                <i class="fas fa-heart mr-1"></i>
                {{lg('',{
                  en: 'Breed Now',
                  zh: '现在繁殖',
                })}}
              </router-link>

              
            </div>
          </div>
        </div>

        <!-- bottom -->
        <div class="mt-3">
          <div class="bg-c py-2">
            <h4 class="text-white mb-0 pl-3 text-center">
              {{lg('',{
                en: 'Properties',
                zh: '属性',
              })}}
            </h4>
          </div>
          <div class="bg-c-lighten-b px-3 py-2 c text-center">
            
            <div class="lion-prop-item">
              <div>
                {{lg('',{
                  en: 'GENDER',
                  zh: '性别',
                })}}
              </div>
              <div class="sp-title bg-c-darken">
                {{lion_data.gender_str }}
              </div>
              <div class="sp-des">
                <!-- !! -->
                {{lg('',{
                  en: 'Common',
                  zh: '',
                })}}
              </div>
            </div>
            
            <div class="lion-prop-item">
              <div>
                {{lg('',{
                  en: 'HAIR',
                  zh: '发色',
                })}}
              </div>
              <div class="sp-title bg-c-darken">
                {{lion_data.hair_str }}
              </div>
              <div class="sp-des">
                <!-- todo... -->
                {{lg('',{
                  en: 'Common',
                  zh: '',
                })}}
              </div>
            </div>

            <div class="lion-prop-item">
              <div>
                {{lg('',{
                  en: 'EYE',
                  zh: '眼睛',
                })}}
              </div>
              <div class="sp-title bg-c-darken">
                {{lion_data.eye_str }}
              </div>
              <div class="sp-des">
                <!-- todo... -->
                {{lg('',{
                  en: 'Common',
                  zh: '',
                })}}
              </div>
            </div>

            <div class="lion-prop-item">
              <div>
                {{lg('',{
                  en: 'MOUTH',
                  zh: '嘴巴',
                })}}
              </div>
              <div class="sp-title bg-c-darken">
                {{lion_data.mouth_str }}
              </div>
              <div class="sp-des">
                <!-- todo -->
                {{lg('',{
                  en: 'Common',
                  zh: '',
                })}}
              </div>
            </div>

            <div class="lion-prop-item">
              <div>
                {{lg('',{
                  en: 'BACKGROUND',
                  zh: '背景',
                })}}
              </div>
              <div class="sp-title bg-c-darken">
                {{lion_data.background_str }}
              </div>
              <div class="sp-des">
                <!-- todo... -->
                {{lg('',{
                  en: 'Common',
                  zh: '',
                })}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-5">
      <div class="bg-c-lighten-b py-4 text-center d-flex align-items-center justify-content-around px-5">

        <!-- <div class="lion-prop-item-b">
          <div class="bg-c-darken text-white">
            {{lg('',{
              en: 'Fighting Score',
              zh: '战斗分值',
            })}}
          </div>
          <div>
            <div>
              {{lg('',{
                en: 'Level',
                zh: '级别',
              })}}
              {{lion_data.battle_level}}
            </div>
            <div>
              {{lg('',{
                en: 'Power',
                zh: '战斗力',
              })}}
              {{lion_data.battle_power}}  
            </div>
            <div>
              {{lg('',{
                en: 'Multiplier',
                zh: '乘机',
              })}}
              {{lion_data.battle_multiplier}}
            </div>
          </div>
        </div> -->

        <div class="lion-prop-item-b">
          <div class="bg-c-darken text-white">
            {{lg('',{
              en: 'Breed Left',
              zh: '繁殖剩余次数',
            })}} 
          </div>
          <div>
            <h1 class="mb-0 c">
              {{lion_data.breedLimitInfo.breedLeft}}
            </h1>
          </div>
        </div>

      </div>
    </div>

    <div>

      <!-- parents -->
      <div
        v-if="lion_data.parent_male.tokenID && lion_data.parent_female.tokenID " 
        class="pt-5">
        <div>
          <h2>
            {{lg('',{
              en: 'Parents',
              zh: '父母',
            })}}
          </h2>
        </div>
        <div class="mt-4">
          <div class="d-flex">

            <div
              class="mr-4"
              :to="{
                name: 'lion_item',
                params: {
                  id: lion_data.parent_female.tokenID
                },
              }"
              >
              <p class="small">
                {{lg('',{
                  en: 'Mother',
                  zh: '妈妈',
                })}}
              </p>
              <lionItemCardSmall 
                :data="lion_data.parent_female"
              />
            </div>

            <div
              class="mr-4"
              :to="{
                name: 'lion_item',
                params: {
                  id: lion_data.parent_male.tokenID
                },
              }"
              >
              <p class="small">
                {{lg('',{
                  en: 'Father',
                  zh: '爸爸',
                })}}
              </p>
              <lionItemCardSmall 
                :data="lion_data.parent_male"
              />
            </div>

          </div>
        </div>
      </div>

      <!-- child -->
      <div
        v-if="lion_data.child_list.length" 
        class="mt-5">
        <div>
          <h2>
            {{lg('',{
              en: 'Children',
              zh: '孩子',
            })}}
          </h2>
        </div>
        <div class="d-flex mt-4">

          <div class="mr-4">
            <div 
              class=""
              v-for="(item,index) of lion_data.child_list"
              :key="index"
              >
              <div
                class=""
                v-if="item.tokenID"
                :to="{
                  name: 'lion_item',
                  params: {
                    id: item.tokenID
                  },
                }"
                >
                <lionItemCardSmall 
                  :data="item"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- old ↓ v-if="0" 的部分不会被打包渲染，不影响性能 -->
    <div v-if="0">
      
      <div class="text-center mt-5 py-5">
        <div class="big-lion-avatar d-inline-block">
          <picColored
            style="max-width: 300px; "
            :img="lion_data.image_url"
          />
        </div>
      </div>

      <div class="mt-5">
        <h2>
          {{lion_data.item_name || 'Lion'}}
          #{{lion_data.tokenId}}
        </h2>
        <div class="d-flex op4">

          <!-- 1 -->
          <span class="mr-3">
            #{{lion_data.tokenId}}
          </span>

          <!-- 2 -->
          <span class="mr-3">
            Gen: {{lion_data.generation }}
          </span>

          <!-- 3 -->
          <span class="mr-3">
            Cooldown: {{lion_data.breedLimitInfo.left_str }}
          </span>
        </div>

        <div class="mt-4">

          <button
            v-if="0 && (lion_data.is_my) && lion_data.is_male && !lion_data.is_in_stud"
            @click="$store.commit('setDataBusKey',{
              data_on_breed: lion_data,
            })"
            class="btn btn-primary"
            >
            <i class="fas fa-heart mr-1 op4"></i>
            {{lg('',{
              en: 'Put into Breed(horse)',
              zh: '',
            })}}
          </button>
        </div>
      </div>

      <div class="my-5">
        <horseItemBlockSelectMate
          :data="lion_data"
        />
      </div>

      <div>
        <h2>
          {{lg('',{
            en: 'Properties',
            zh: '',
          })}}
        </h2>
      </div>

      <div 
        class="mt-4" 
        :class="{'pb-5': lion_data.parent_male.tokenId != undefined && lion_data.child_list.length}"
        style=""
        >
        <div class="sp-top-num-info">
          <lionItemNumBlock 
            :data="lion_data"
            :cfg_show_icon="false"
          />
        </div>

        <!-- parents -->
        <div
          v-if="lion_data.parent_male.tokenId && lion_data.parent_female.tokenId " 
          class="pt-5">
          <div>
            <h2>
              {{lg('',{
                en: 'Parents',
                zh: '',
              })}}
            </h2>
          </div>
          <div class="mt-4">
            <div class="d-flex">

              <div
                class="mr-4"
                :to="{
                  name: 'lion_item',
                  params: {
                    id: lion_data.parent_female.tokenId
                  },
                }"
                >
                <p class="small">
                  {{lg('',{
                    en: 'Mother',
                    zh: '',
                  })}}
                </p>
                <lionItemCardSmall 
                  :data="lion_data.parent_female"
                />
              </div>

              <div
                class="mr-4"
                :to="{
                  name: 'lion_item',
                  params: {
                    id: lion_data.parent_male.tokenId
                  },
                }"
                >
                <p class="small">
                  {{lg('',{
                    en: 'Father',
                    zh: '',
                  })}}
                </p>
                <lionItemCardSmall 
                  :data="lion_data.parent_male"
                />
              </div>

            </div>
          </div>
        </div>

        <!-- child -->
        <div
          v-if="lion_data.child_list.length" 
          class="mt-5">
          <div>
            <h2>
              {{lg('',{
                en: 'Children',
                zh: '',
              })}}
            </h2>
          </div>
          <div class="d-flex mt-4">

            <div class="mr-4">
              <div 
                class=""
                v-for="(item,index) of lion_data.child_list"
                :key="index"
                >
                <div
                  class=""
                  v-if="item.tokenId"
                  :to="{
                    name: 'lion_item',
                    params: {
                      id: item.tokenId
                    },
                  }"
                  >
                  <lionItemCardSmall 
                    :data="item"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import picColored from '@/views/_cp_base/pic_colored.vue'
import lionItemNumBlock from '@/views/_cp_busi/lion_item_num_block.vue'
import lionItemCardSmall from '@/views/_cp_busi/lion_item_card_small.vue'
import horseItemBlockSelectMate from '@/views/_cp_busi//horse_item_block_select_mate.vue'

export default {
  name: 'lionDetail',
  components: {
    lionItemNumBlock,
    lionItemCardSmall,
    picColored,
    horseItemBlockSelectMate,
  },
  props: [],
  data() {
    return {
      lion_data: null,
      status_loading_lion_data: false,

      is_approved: false,
      status_checking_approve: true,

      status_ajaxing_approve: false,
    }
  },
  computed: {
    is_my(){
      let v = this

      // from 上一个页面是 my_collection 则直接判定为true
      if( v.$store.state.app.last_path.indexOf("/my_collection") >= 0 ){
        return true
      }

      // 
      if( (v.$store.state.app.data_my_lion || []).find(i => i.tokenId === (v.lion_data || {}).tokenId) || (v.lion_data || {}).is_my){
        return true
      }else{
        return false
      }
    },
    address_my(){
      return this.$store.state.web3.account;
    },
  },
  watch: {
    address_my(){
      this.run()
    },
  },
  methods: {
    ...mapActions([
      'getHorseInfo',
      'cancelAskOrder',
      'createAskOrder',
      'buyNFT',
      'hasApproveNFTMarket',
      'hasApproveBuy',
      'approveNFTMarket',
      'approveBuy',
    ]),

    async actionCancelSell(){
      let v = this

      try{
        await v.cancelAskOrder({
          address_my: this.address_my,
          horse_data: this.lion_data,
        })

        setTimeout(function(){
          v.run()
        },8000)
      } catch {
        // 
      }
    },
    actionSell(){
      let v = this
      v.$store.commit('setDataBusKey',{
        data_on_sell: v.lion_data,
      })
    },
    async actionBuy(){
      let v = this

      try{
        let form = {
          address_my: this.address_my,
          horse_data: this.lion_data,
          form_price: this.lion_data.price,
        }
        await v.buyNFT(form)

        setTimeout(function(){
          v.run()
        },8000)
      } catch {
        // 
      }
    },
    async actionApprove(){
      let v = this

      if(v.status_ajaxing_approve){
        return
      }

      let fn_name = v.is_my ? 'approveNFTMarket' : 'approveBuy'
      
      v.status_ajaxing_approve = true

      try{
        await v[fn_name]({
          address: v.address_my
        })
        
        setTimeout(function(){
          v.is_approved = true
          v.status_ajaxing_approve = false
        },8000)
      } catch {
        v.status_ajaxing_approve = false
      }
      
    },
    async checkApprove(){
      let v = this

      let fn_name = v.is_my ? 'hasApproveNFTMarket' : 'hasApproveBuy'
      
      v.status_checking_aprrove = true
      let res  = await v[fn_name]({
        address: v.address_my
      })
      console.log('==== approve status:' + res)
      v.is_approved = res
      v.status_checking_aprrove = false
    },

    async getPageData(){
      let v = this

      v.status_checking_approve = true
      let res = await v.getHorseInfo({
        horseID: v.$route.params.id,
      })
      v.status_checking_approve = false

      res = v.transHorseData(res)
      v.lion_data = res
    },
    
    run(){
      let v = this
      v.getPageData()
      v.checkApprove()
    },
  },
  created() {
    let v = this
    v.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .page-horse-item{

    .lion-box{
      // height: 460px;

      .page-main-pic{
        padding: 4px;
        padding-bottom: 0;
        border-radius: 4px;
        .sp-avatar{
          width: 400px; 
          height: 400px; 
          background: #fff;
        }
      }

      @media(max-width: 789px){
        flex-wrap: wrap;
        height: auto;
        .page-main-pic{
          margin-bottom: 20px;
          width: 100%;
          .sp-avatar{
            width: 100%;
            height: 450px;
            /deep/ img{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }


    .big-lion-avatar{
    }
    .sp-top-num-info{
      
    }
    .sp-gender-tag{
      border: 1px solid $c;
      background-color: #282828;
      transform: translateY(-12px);
      border-radius: 4px;
      padding: 0px 6px;
      height: 25px;
      line-height: 25px;
      display: inline-block;
      font-size: 12px;
    }

    .lion-prop-item{
      border: 4px solid darken($c,10);
      display: inline-block;
      margin-top: 10px;
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      font-size: 14px;
      width: 140px;
      @media(max-width: 789px){
        margin-left: 20px;
        margin-right: 20px;
      }
      
      .sp-title{
        font-weight: bold;
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        color: #fff;
      }
      .sp-des{
        font-size: 12px;
      }
    }

    .lion-prop-item-b{
      width: 200px;
      display: inline-block;
      background-color: #fff;
      margin-left: 5px;
      margin-right: 5px;

      .sp-big-text{
        font-size: 24px;
      }
    }
  }
</style>